export default __webpack_public_path__ + "static/media/AAPG-Pivoting-3.8f14425e.jpg";